import { render, staticRenderFns } from "./user-data-card.vue?vue&type=template&id=243f2084&scoped=true&"
import script from "./user-data-card.vue?vue&type=script&lang=ts&"
export * from "./user-data-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f2084",
  null
  
)

export default component.exports